<template>
  <div class="page page-services">
    <section class="services-hero">
      <div class="hero-content">
        <p class="eyebrow">{{ isEnglish ? 'Nyenyezia Forex' : 'Nyenyezia Forex' }}</p>
        <h1>{{ isEnglish ? 'Currency services for everyday international needs' : 'Des services de change pour vos besoins internationaux' }}</h1>
        <p>
          {{ isEnglish ? 'Clear exchange rates, practical support, and simple service for customers who need to exchange or transfer money.' : 'Des taux lisibles, un accompagnement pratique et un service simple pour vos besoins de change ou de transfert.' }}
        </p>
        <div class="hero-actions">
          <router-link :to="localizedPath('/taux-de-change')" class="cta-button">{{ isEnglish ? 'View Rates' : 'Voir les taux' }}</router-link>
          <router-link :to="localizedPath('/contact')" class="cta-button cta-secondary">{{ isEnglish ? 'Contact Us' : 'Nous contacter' }}</router-link>
        </div>
      </div>
    </section>

    <section class="services">
      <div class="section-heading">
        <p class="eyebrow">{{ isEnglish ? 'Services' : 'Services' }}</p>
        <h2>{{ isEnglish ? 'What Nyenyezia Forex can help you with' : 'Ce que Nyenyezia Forex peut faire pour vous' }}</h2>
      </div>
      <div class="services-list">
        <article class="service-card" v-for="(service, index) in displayedServices" :key="index">
          <img :src="service.icon" :alt="service.title" class="service-icon" />
          <h3 class="service-title">{{ service.title }}</h3>
          <p class="service-description">{{ service.description }}</p>
          <router-link :to="service.ctaTo" class="text-link">{{ service.ctaText }}</router-link>
        </article>
      </div>
    </section>

    <section class="service-cta">
      <div>
        <h2>{{ isEnglish ? 'Ready to confirm a rate?' : 'Prêt à confirmer un taux ?' }}</h2>
        <p>{{ isEnglish ? 'Check the public rates or contact the team before your exchange.' : 'Consultez les taux publics ou contactez l’équipe avant votre opération.' }}</p>
      </div>
      <div class="hero-actions">
        <router-link :to="localizedPath('/taux-de-change')" class="cta-button">{{ isEnglish ? 'View Rates' : 'Voir les taux' }}</router-link>
        <router-link :to="localizedPath('/contact')" class="cta-button cta-secondary">{{ isEnglish ? 'Contact Us' : 'Nous contacter' }}</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ServicesPage",
  data() {
    return {
      services: [
        {
          ctaText: "Demander ce service",
          ctaTo: "/contact?subject=exchange",
          icon: "images/trading.png",
          title: "Échange de devises",
          description: "Achat et vente de devises avec des taux affichés clairement et confirmés avant l’opération.",
        },
        {
          ctaText: "Nous contacter",
          ctaTo: "/contact?subject=international-transfert",
          icon: "images/accounts.png",
          title: "Transfert d’argent",
          description: "Accompagnement pour vos besoins de transfert avec un processus simple et un suivi humain.",
        },
        {
          ctaText: "Parler à l’équipe",
          ctaTo: "/contact?subject=consultation",
          icon: "images/analysis.png",
          title: "Consultation et accompagnement",
          description: "Aide pratique pour comprendre les taux, les options disponibles et les étapes à suivre.",
        },
        {
          ctaText: "Voir les taux",
          ctaTo: "/taux-de-change",
          icon: "images/analysis.png",
          title: "Affichage des taux",
          description: "Consultation rapide des taux achat et vente sur le site et le tableau d’affichage public.",
        },
      ],
      servicesEn: [
        {
          ctaText: "Request this service",
          ctaTo: "/en/contact?subject=exchange",
          icon: "images/trading.png",
          title: "Currency Exchange",
          description: "Buy and sell currencies with rates displayed clearly and confirmed before the transaction.",
        },
        {
          ctaText: "Contact Us",
          ctaTo: "/en/contact?subject=international-transfert",
          icon: "images/accounts.png",
          title: "Money Transfer",
          description: "Support for money transfer needs with a simple process and human follow-up.",
        },
        {
          ctaText: "Talk to the Team",
          ctaTo: "/en/contact?subject=consultation",
          icon: "images/analysis.png",
          title: "Consultation and Guidance",
          description: "Practical help to understand rates, available options, and the next steps.",
        },
        {
          ctaText: "View Rates",
          ctaTo: "/en/taux-de-change",
          icon: "images/analysis.png",
          title: "Rate Display",
          description: "Quick access to buy and sell rates on the website and public rate board.",
        },
      ],
    }
  },
  computed: {
    isEnglish() {
      return this.$route.path.startsWith('/en');
    },
    displayedServices() {
      return this.isEnglish ? this.servicesEn : this.services;
    }
  },
  methods: {
    localizedPath(path) {
      if (!this.isEnglish) return path;
      return path === '/' ? '/en' : '/en' + path;
    }
  }
};
</script>

<style scoped>
.page-services {
  background: #f5f7fb;
  color: #001041;
}
.services-hero {
  background:
    linear-gradient(90deg, rgba(0,16,65,0.88), rgba(0,16,65,0.58)),
    url('@/assets/services.jpg');
  background-position: center;
  background-size: cover;
  color: #fff;
  padding: 104px 20px 90px;
}
.hero-content,
.service-cta {
  margin: 0 auto;
  max-width: 1120px;
}
.hero-content {
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.eyebrow {
  color: #c39446;
  font-size: 0.84rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin: 0 0 10px;
  text-transform: uppercase;
}
.services-hero h1 {
  font-size: clamp(2.3rem, 5vw, 4.2rem);
  line-height: 1.08;
  margin: 0;
}
.services-hero p {
  font-size: 1.12rem;
  line-height: 1.65;
  margin: 18px auto 0;
  max-width: 680px;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 28px;
}
.cta-button {
  background-color: #c39446;
  border-radius: 5px;
  color: white;
  display: inline-block;
  font-weight: 700;
  padding: 12px 20px;
  text-decoration: none;
}
.cta-secondary {
  background: #001041;
}
.services {
  padding: 78px 20px;
}
.section-heading {
  margin: 0 auto 34px;
  max-width: 780px;
  text-align: center;
}
.section-heading h2,
.service-cta h2 {
  color: #001041;
  font-size: clamp(2rem, 4vw, 2.8rem);
  line-height: 1.15;
  margin: 0;
}
.services-list {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 0 auto;
  max-width: 1120px;
}
.service-card {
  background: #fff;
  border: 1px solid #dfe4ee;
  border-radius: 8px;
  box-shadow: 0 16px 38px rgba(0,16,65,0.08);
  padding: 28px 22px;
  text-align: left;
}
.service-icon {
  height: 54px;
  margin-bottom: 20px;
  object-fit: contain;
  width: 54px;
}
.service-title {
  color: #001041;
  font-size: 1.18rem;
  margin: 0 0 10px;
}
.service-description {
  color: #4d5a70;
  line-height: 1.58;
  margin: 0 0 20px;
}
.text-link {
  color: #c39446;
  font-weight: 800;
  text-decoration: none;
}
.service-cta {
  align-items: center;
  background: #fff;
  border: 1px solid #dfe4ee;
  border-radius: 8px;
  box-shadow: 0 16px 38px rgba(0,16,65,0.08);
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 86px;
  padding: 30px;
}
.service-cta p {
  color: #4d5a70;
  margin: 10px 0 0;
}
@media (max-width: 980px) {
  .services-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .services-hero {
    padding: 84px 18px 72px;
  }
  .services-list,
  .service-cta {
    grid-template-columns: 1fr;
  }
  .service-cta {
    align-items: stretch;
    flex-direction: column;
  }
  .hero-actions,
  .cta-button {
    width: 100%;
  }
  .cta-button {
    text-align: center;
  }
}
</style>
